// Threads
import ClassNames from 'classnames';
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux'
import { scroller } from 'react-scroll';

import Filters from './Filters';
import InsiderNotificationForm from './InsiderNotificationForm';
import MessageList from './MessageList';
import ThreadForm from './ThreadForm';
import ThreadList from './ThreadList';
import WelcomeHelper from './WelcomeHelper';
import { getTranslator } from '../locales';


@connect((Store) => {
  const t = getTranslator();

  return {
    locale: Store.settings.locale,
    labels: {
      ASK_A_NEW_QUESTION: t.t('Ask a new question'),
      MORE_UNREADS: t.t('More Unreads')
    },
    luser: Store.luser,
    threads: Store.threads.list,
    isAskFormOpened: Store.chat.isAskFormOpened,
    selectedThread: Store.threads.selectedThread,
    nbThreads: Store.threads.nbThreads,
    followedThreadIds: Store.luser.followedThreadIds,
    filterHidden: Store.filters.hidden,
    filterTitles: Store.filters.filterTitles,
    selectedFilter: Store.filters.selectedFilter,
    whichToolboxOpened: Store.filters.whichToolboxOpened,
    threadsOrdering: Store.settings.threadsOrdering,
    mobilePanels: Store.chat.mobilePanels
  };
})

export default class Threads extends React.Component {
  /**
   * Constructor
   * Set an initial state with refs to unvisible thread DOM elements above
   * and below the viewport.
   *
   * @param  {Object} props Component props.
   */
  constructor(props) {
    super(props);
    this.state = { topUnvisible: [], bottomUnvisible: [] };
  }

  handleClickToggleQuestionForm() {
    if (!this.props.isAskFormOpened){
      this.props.mobilePanelChange('thread_form');
    } else {
      this.props.mobilePanelChange('messages');
    }
  }

  /**
   * Add a target thread to the target list depending on its position.
   *
   * @param  {string} position 'top' or 'bottom'.
   * @param  {string} threadContainerId DOM id of the thread item element.
   */
  addScrollBannerTarget(position, threadContainerId) {

    // Top banner
    if (position === 'top') {
      const topUnvisible = [...this.state.topUnvisible];

      // Only add and setState (implying re-rendering) if it's not in there
      if (!_.includes(topUnvisible, threadContainerId)) {
        topUnvisible.push(threadContainerId);
        this.setState({ topUnvisible });
      }
    }

    // Bottom banner
    if (position === 'bottom') {
      const bottomUnvisible = [...this.state.bottomUnvisible];

      // Only add and setState (implying re-rendering) if it's not in there
      if (!_.includes(bottomUnvisible, threadContainerId)) {
        bottomUnvisible.push(threadContainerId);
        this.setState({ bottomUnvisible });
      }
    }
  }

  /**
   * Get next target thread DOM element id below the viewport.
   *
   * @return {String} DOM element id.
   */
  getBottomTarget() {
    const length = this.state.bottomUnvisible.length;

    if (length > 0) {
      return this.state.bottomUnvisible[length - 1];
    }

    return null;
  }

  /**
   * Get next target thread DOM element id above the viewport.
   *
   * @return {String} DOM element id.
   */
  getTopTarget() {
    const length = this.state.topUnvisible.length;

    if (length > 0) {
      return this.state.topUnvisible[length - 1];
    }

    return null;
  }

  /**
   * Remove a target thread from the target list depending on its position.
   *
   * @param  {string} position 'top' or 'bottom'.
   * @param  {string} threadContainerId DOM id of the thread item element.
   */
  removeScrollBannerTarget(threadContainerId) {
    const topUnvisible = [...this.state.topUnvisible];
    const bottomUnvisible = [...this.state.bottomUnvisible];

    // Only remove and setState (implying re-rendering) if it's there
    if (_.includes(topUnvisible, threadContainerId)) {
      const topUnvisible = _.without(
        this.state.topUnvisible,
        threadContainerId
      );
      this.setState({ topUnvisible });
    }

    // Only remove and setState (implying re-rendering) if it's there
    if (_.includes(bottomUnvisible, threadContainerId)) {
      const bottomUnvisible = _.without(
        this.state.bottomUnvisible,
        threadContainerId
      );
      this.setState({ bottomUnvisible });
    }
  }

  /**
   * Handler to scroll to the next unread target thread (top or bottom)
   *
   * @param  {string} position 'top' or 'bottom'
   */
  handleScrollToNextTarget(position) {
    let target = null;
    let offset = 0;

    if (position === 'top') {
      target = this.getTopTarget();
      offset = 50;
    }

    if (position === 'bottom') {
      target = this.getBottomTarget();
      offset = 72;
    }

    // Scroll to target DOM element if defined
    if (target) {
      scroller.scrollTo(target, {
        duration: 500,
        smooth: true,
        // ContainerId is using a ref to the Threadlist component
        // See 'listRef' prop passed to Threadlist component in render()
        containerId: this.listDOMEl ? this.listDOMEl.id : null,
        offset
      });
    }
  }

  render() {
    const threadsActivityClass = ClassNames({
      threads_activity: true,
      'no-filters': this.props.filterHidden

    });
    const newQuestionButtonClasses = ClassNames({
      fright: true,
      'btn btn-primary btn-round' : true,
      'brandedColor_bg brandedColorLight_border': true,
      opened: this.props.isAskFormOpened
    });

    let threadsList = this.props.threads;

    if (this.props.selectedFilter !== 'all') {
      switch (this.props.selectedFilter) {
        case 'unread': {
          threadsList = _.filter(this.props.threads, thread => {
            return (thread.read !== true)
          });
          break;
        }
        case 'unanswered': {
          threadsList = _.filter(this.props.threads, thread => {
            return (thread.unanswered === true || thread.unanswered === 'true')
          });
          break;
        }
        case 'yours': {
          threadsList = _.filter(this.props.threads, thread => {
            return (thread.author.id === this.props.luser.id)
          });
          break;
        }
        case 'followed': {
          threadsList = _.filter(this.props.threads, thread => {
            return (_.indexOf(this.props.followedThreadIds, thread.id) >= 0)
          });
          break;
        }
        case 'search': {
          break;
        }
        default: {
          const selectedCategoryId = this.props.selectedFilter.replace('cat', '');
          threadsList = _.filter(this.props.threads, thread => {
            return (thread.categoryId == selectedCategoryId)
          });
        }
      }
    }
    const nbThreads = threadsList.length;
    const sortOrder = this.props.threadsOrdering === 'createdAt' ? 'asc' : 'desc';

    const topBannerClassnames = ClassNames({
      'thread-banner': true,
      top: true,
      'brandedColor_bg': true,
      hide: (this.state.topUnvisible.length === 0)
    });

    const bottomBannerClassnames = ClassNames({
      'thread-banner': true,
      bottom: true,
      'brandedColor_bg': true,
      hide: (this.state.bottomUnvisible.length === 0)
    });

    const selectedFilterLabel = (() => {
      let categoryKey = this.props.selectedFilter;

      if (this.props.selectedFilter.startsWith('cat')) {
        categoryKey = this.props.selectedFilter.substr(3);
      }
      return this.props.filterTitles[categoryKey];
    })();

    const t = getTranslator();
    const filterTitle = t.exists(selectedFilterLabel) ? t.t(selectedFilterLabel, nbThreads) : selectedFilterLabel;

    return (
      <div className={threadsActivityClass}>
        <Filters mobilePanelChange={this.props.mobilePanelChange.bind(this)} />
        <div className={this.props.mobilePanelClassName('threads')}>
          <div className='heading'>
            <h2>{filterTitle} <span className='nb'>(&nbsp;{nbThreads}&nbsp;)</span></h2>
            <button className={newQuestionButtonClasses}
              value='+'
              onClick={this.handleClickToggleQuestionForm.bind(this)}
              title={this.props.labels.ASK_A_NEW_QUESTION}
            >
              <i className='pe-7s-comment'></i>
              <i className='pe-7s-plus brandedColor_bg'></i>
            </button>
            <div className='clear'></div>
          </div>
          <div onClick={(() => this.handleScrollToNextTarget('top'))} className={topBannerClassnames}>{this.props.labels.MORE_UNREADS}<i className='pe-7s-angle-up'></i></div>
          <ThreadList
            listRef={el => this.listDOMEl = el}
            threads={threadsList}
            sortKey={this.props.threadsOrdering}
            sortOrder={sortOrder}
            mobilePanelChange={this.props.mobilePanelChange.bind(this)}
            addScrollBannerTarget={this.addScrollBannerTarget.bind(this)}
            removeScrollBannerTarget={this.removeScrollBannerTarget.bind(this)}
          />
          <div onClick={(() => this.handleScrollToNextTarget('bottom'))} className={bottomBannerClassnames}>{this.props.labels.MORE_UNREADS}<i className='pe-7s-angle-down'></i></div>
          <div className='clear'></div>
        </div>
        {
          (() => {
            if (!this.props.selectedThread) {
              return (
                <WelcomeHelper
                  handleClickToggleQuestionForm={this.handleClickToggleQuestionForm.bind(this)}
                  mobilePanelClassName={this.props.mobilePanelClassName.bind(this)}
                  mobilePanelChange={this.props.mobilePanelChange.bind(this)}
                />
              );
            } else {
              return (
                <MessageList
                  mobilePanelClassName={this.props.mobilePanelClassName.bind(this)}
                  mobilePanelChange={this.props.mobilePanelChange.bind(this)}
                />
              );
            }
          })()
        }
        <div className='clear'></div>
        {
          <ThreadForm
            mobilePanelClassName={this.props.mobilePanelClassName.bind(this)}
            mobilePanelChange={this.props.mobilePanelChange.bind(this)}
          />
        }
        {
          (() => {
            if (this.props.luser.insider)
            {
              return <InsiderNotificationForm
                      mobilePanelClassName={this.props.mobilePanelClassName.bind(this)}
                      mobilePanelChange={this.props.mobilePanelChange.bind(this)}
                    />
            }
          })()
        }
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/Threads.jsx